import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import styles from "./styles.module.scss";

const WideHeader = ({ title, children }) => {
    return (
        <div className={ styles.header }>
            <Helmet title={ `${ title } - Bloomberg` } />
            <h1 className={ styles.title }>{ title }</h1>
            { children }
        </div>
    );
};

WideHeader.propTypes = {
    title: PropTypes.string
};

export default WideHeader;
